import { render, staticRenderFns } from "./ZjyAvatar.vue?vue&type=template&id=f5b38a2e&scoped=true"
import script from "./ZjyAvatar.vue?vue&type=script&lang=js"
export * from "./ZjyAvatar.vue?vue&type=script&lang=js"
import style0 from "./ZjyAvatar.vue?vue&type=style&index=0&id=f5b38a2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b38a2e",
  null
  
)

export default component.exports